import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo, gql } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { CouresespageContentModel } from './models/couresespage.model';
import { CouresesContentResponse } from './models/couresespage-response.model';



@Injectable({
  providedIn: 'root',
})
export class CouresesContentService extends BaseGQLService<CouresesContentResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: CouresespageContentModel,
        clientName: 'CouresesContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryCoursesContentsWithTotal',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }

  override document = gql`
query RootQuery($filter:String!,$skip:Int, $top:Int)
{
  ${this.config.rootTypeName}(filter:$filter,skip:$skip, top:$top)
  {
      ${this.config.wrapperTypeName
    ? `${this.config.wrapperTypeName} { ${this.buildGQLProps()} } ${this.config.extraProps}`
    : `${this.buildGQLProps()}`
  }
  }
}`;


}


